var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.509 1.691a7.144 7.144 0 0 1-2.063.569 3.62 3.62 0 0 0 1.58-1.997 7.173 7.173 0 0 1-2.282.876A3.575 3.575 0 0 0 12.122 0 3.6 3.6 0 0 0 8.53 3.608c0 .282.032.558.093.823A10.187 10.187 0 0 1 1.219.66a3.606 3.606 0 0 0-.486 1.814c0 1.252.634 2.357 1.598 3.003a3.545 3.545 0 0 1-1.627-.451v.045a3.604 3.604 0 0 0 2.881 3.538 3.558 3.558 0 0 1-1.622.062 3.596 3.596 0 0 0 3.355 2.506A7.184 7.184 0 0 1 0 12.672a10.143 10.143 0 0 0 5.507 1.621c6.607 0 10.22-5.499 10.22-10.267 0-.157-.003-.312-.01-.467a7.302 7.302 0 0 0 1.792-1.868","fill":"#FFF","fillRule":"evenodd"}));
}

Twitter.displayName = "Twitter";

Twitter.defaultProps = {"width":"18","height":"14","viewBox":"0 0 18 14"};

module.exports = Twitter;

Twitter.default = Twitter;
